import { Select } from "antd";
import { ActAsTypes } from "enums/actAsTypes.ts";
import { PageTypes } from "enums/pageTypes";
import { useCurrentUser } from "hooks/useCurrentUser";
import { usePageType } from "hooks/usePageType";
import { useIntl } from "react-intl";
import { useLocation, useNavigate, useParams } from "react-router-dom";

export const ChangeUserRole = () => {
  const { pathname } = useLocation();
  const { customerId, sport, organizationId } = useParams();
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const pageType = usePageType();
  const currentUser = useCurrentUser();

  if (pathname.endsWith("/role") || currentUser.roles.length === 0) {
    return;
  }

  if (currentUser?.roles?.length <= 1) {
    return;
  }

  return (
    <>
      <i className="fa-solid fa-users-gear" style={{ marginRight: 5 }} />
      <Select
        popupMatchSelectWidth={false}
        value={pageType === PageTypes.Admin ? ActAsTypes.Admin : ActAsTypes.TeamManager}
        onChange={(value) => {
          if (value === ActAsTypes.Admin) {
            navigate(`/${customerId}/${sport}/${organizationId}/admin`);
          } else if (value === ActAsTypes.TeamManager) {
            navigate(`/${customerId}/${sport}/${organizationId}/entities`);
          }
        }}
        options={[
          {
            label: formatMessage({ id: "actAsTypes.admin" }),
            value: ActAsTypes.Admin,
            disabled: pageType === PageTypes.Admin,
          },
          {
            label: formatMessage({ id: "actAsTypes.team-manager" }),
            value: ActAsTypes.TeamManager,
            disabled: pageType === PageTypes.TeamManager,
          },
        ]}
      />
    </>
  );
};
